<template>
  <non-property-layout>
    <div class="flex flex-col justify-center min-h-600">
      <div v-if="doesClientExist">
        <!-- component -->
        <div
          class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
        >
          <div class="px-8 py-8 rounded-xl">
            <h1 name="login-title" class="m-2 font-bold text-center text-2xl">
              Login to Safetynet
            </h1>

            <Loading v-if="isLoggingIn" />
            <ErrorDisplay
              label="Couldn't log in"
              :message="loginError"
              :isVisible="loginError != null"
            />

            <form action="" class="mt-8">
              <div class="my-5 text-sm">
                <label for="username" class="block text-black">Username</label>
                <input
                  id="username"
                  v-model="email"
                  type="text"
                  autofocus
                  class="w-full px-4 text-xl font-mono py-3 mt-2 bg-gray-200 border border-gray-400 rounded-sm focus:outline-none"
                  placeholder="caleb@mycompany.com"
                  autocomplete="username"
                />
              </div>
              <div class="my-5 text-sm">
                <label for="password" class="block text-black">Password</label>
                <input
                  id="password"
                  v-model="password"
                  type="password"
                  autocomplete="current-password"
                  class="w-full px-4 py-3 mt-2 text-xl font-mono bg-gray-200 border border-gray-400 rounded-sm focus:outline-none"
                  placeholder="Password"
                />
                <div class="flex justify-end mt-2 text-xs text-gray-600">
                  <router-link
                    class="duration-100 hover:text-black"
                    id="reset-password"
                    title="reset-password"
                    :to="`/forgotpassword`"
                  >
                    Forgot Password?
                  </router-link>
                </div>
              </div>
              <div class="flex flex-wrap justify-between flex-row-reverse mt-8">
                <button
                  id="login_button"
                  class="w-40 flex py-3 px-3 text-center text-white duration-300 bg-btn hover:bg-blue-500 rounded"
                  @click.prevent="loginWithEmail"
                >
                  <span class="i-icon i-icon-door-handle">
                    <svg viewBox="0 0 64 64" fill="none" width="28px" height="28px">
                      <rect
                        x="6"
                        y="4"
                        width="26"
                        height="40"
                        rx="2"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        style="width: 48px; height: 55px"
                      />
                      <path
                        d="M14 34H24"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M42 20V14H23.0004C22.0882 12.7856 20.6358 12 19 12C16.2386 12 14 14.2386 14 17C14 19.7614 16.2386 22 19 22C20.6358 22 22.0882 21.2144 23.0004 20H42Z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span class="flex-grow text-xl pr-5">Login</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-else>
        <h1>Error 404: Page not found</h1>
      </div>
    </div>
  </non-property-layout>
</template>

<script setup lang="ts">
import { useUserStore } from "../store/userStore";
import { useBldgStore } from "../store/bldgStore";
//import { DoorHandle as IconDoorHandle } from "@icon-park/vue-next";
// Okay as IconOkta,
// Google as IconGoogle,

const userStore = useUserStore();
const bldgStore = useBldgStore();
const router = useRouter();
const route = useRoute();

let clientSystemName: string | null = null;
let regionName: string | null = null;
onMounted(async () => {
  clientSystemName = Array.isArray(route.params?.clientsystemname)
    ? route.params.clientsystemname[0]
    : route.params.clientsystemname;
  regionName = Array.isArray(route.params?.regionname)
    ? route.params.regionname[0]
    : route.params.regionname;

  doesClientExist.value = await userStore.checkClient(clientSystemName);

  console.log(
    `Login mounted. clientsystemname='${clientSystemName}', region='${regionName}'`
  );
});

let doesClientExist = ref(false);

let isLoggingIn = ref(false);
let loginError = ref<string | null>(null);
let email = ref("");
let password = ref("");
var returnUrl = ref<string | null>(null);

async function loginWithEmail() {
  console.log(`Attempting login for: ${email.value}`);
  isLoggingIn.value = true;
  loginError.value = "";

  let loginResult = await userStore.loginUser(
    email.value,
    password.value,
    null,
    clientSystemName,
    regionName,
    null
  );

  if (loginResult && !loginResult.error) {
    if (loginResult.upgradePassword) {
      //router.push("/" + property.value.siteCode + "/setpassword?user=" + email.value);
    } else if (userStore.isLoggedIn) {
      //userStore.getUser(bldgStore.siteCode, bldgStore.property.portalId, true);
      if (loginResult.siteCode) {
        bldgStore.tryGetBuildingData(loginResult.siteCode, true);
        if (returnUrl.value && returnUrl.value.startsWith("/" + loginResult.siteCode)) {
          router.replace(returnUrl.value);
        } else {
          router.replace("/" + loginResult.siteCode);
        }
      }

      console.info("No site code found. Redirect to building picker");
      if (loginResult.hasRegionAccess && regionName?.length > 0) {
        router.push(`/portallist/${clientSystemName}/${regionName}`);
      } else if (clientSystemName?.length > 0 && loginResult.hasClientAccess) {
        router.push(`/portallist/${clientSystemName}`);
      } else {
        loginError.value =
          "Sorry, you do not have access. Please check your link and contact support";
        isLoggingIn.value = true;
      }
    }
  } else {
    // if there is a login error
    loginError.value = loginResult?.error ?? "Invalid Login";
    isLoggingIn.value = false;
  }
}
</script>
